import { useTranslation } from 'react-i18next';

interface QuickAction {
  id: string;
  icon: string;
  label: string;
  badge?: number;
  onClick: () => void;
}

interface QuickActionGridProps {
  actions: QuickAction[];
}

export default function QuickActionGrid({ actions }: QuickActionGridProps) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {actions.map((action) => (
        <button
          key={action.id}
          onClick={action.onClick}
          className="bg-white rounded-2xl p-4 shadow-md hover:shadow-lg transition-all active:scale-95"
        >
          <div className="relative w-12 h-12 flex items-center justify-center bg-gray-50 rounded-xl mx-auto mb-3">
            <i className={`${action.icon} text-2xl text-gray-700`}></i>
            {action.badge !== undefined && action.badge > 0 && (
              <div className="absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center bg-red-500 text-white text-xs font-bold rounded-full">
                {action.badge}
              </div>
            )}
          </div>
          <p className="text-sm font-semibold text-gray-900">{action.label}</p>
        </button>
      ))}
    </div>
  );
}
